function initScrollFilters() {
    const $container = document.querySelector('.filters');
    if ($container) {
        const $filters = $container.querySelectorAll('.scroll-filter');
        const isMobile = window.innerWidth <= 768;
        let $oldElement;
        let $currentElement;
        function init() {
            if ($filters && $filters.length) {
                $filters.forEach($filter => {
                    $filter.addEventListener('click', () => {
                        const $selectFilterId = $filter.querySelector('[id]');
                        const $selectFilterFor = $filter.querySelector('[for]');
                        if ($selectFilterId) {
                            $currentElement = $selectFilterId.getAttribute('id');
                        }
                        else if ($selectFilterFor) {
                            $currentElement = $selectFilterFor.getAttribute('for');
                        }
                        else {
                            $currentElement = '';
                        }
                        const widthContainer = $container.clientWidth / 2;
                        const widthFilter = $filter.clientWidth / 2;
                        let position = $filter.offsetLeft + widthFilter;
                        position = position - widthContainer;
                        if ($currentElement !== $oldElement) {
                            $container.scrollLeft = position;
                            if (isMobile) {
                                $container.animate([
                                    { transform: `translateX(${position}px)` },
                                    { transform: `translateX(0px)` }
                                ], {
                                    duration: 400
                                });
                            }
                        }
                        $oldElement = $currentElement;
                    });
                });
            }
        }
        init();
    }
}
window.addEventListener('load', initScrollFilters);
